import i18n from "i18next";
import XHR from 'i18next-xhr-backend';
import { initReactI18next } from "react-i18next";
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
let langCookie = cookies.get('cvlrglang')
const lang = langCookie ? langCookie.toLowerCase().split('_')[0] : 'en';
const translationBase = process.env.REACT_APP_TRANSLATION_BASE || 'https://wcms-web-dev.osram.info/apps/cvlrg/lang'

i18n
  .use(XHR)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: () => {
        return `${translationBase}/${lang}.json`;
      },
      crossDomain: false,
    },
    
    lng: lang,
    fallbackLng: 'en',
    ns: ["translations"],
    defaultNS: "translations",
    debug: false,

    keySeparator: true, // we use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    },
    
  });

  export default i18n;
